// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"24d1cfaa","573":"4852379e","799":"67fb6941"}[chunkId] + ".chunk.js";
};